export const SAY_HELLO = 'SAY_HELLO';